import { isCPF, isCEP } from 'brazilian-values';
import emailValidator from 'email-validator';
import { checkClient } from 'services/userService';
import { verifyIfItsValid } from 'services/emailService';
import { phoneValidation } from 'utils/phoneUtils';
import {
  isValidExpire,
  isValidNameOfCard,
  hasInitialSpace,
} from 'utils/customValidation';

export const emailableRuleChecker = async (value) => {
  const isAValidEmail =
    emailValidator.validate(value) && (await verifyIfItsValid(value));

  return isAValidEmail || 'E-mail inválido';
};

export const validEmailRegex = (value) =>
  emailValidator.validate(value) || 'E-mail inválido';

export const generalRequiredWord = (text) => ({
  required: `${text} é obrigatório`,
});

export const minCharacters = (characters = 3) => ({
  minLength: {
    value: characters,
    message: `Mínimo de ${characters} caracteres`,
  },
});

export const patternText = {
  pattern: {
    value: /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g,
    message: 'Somente letras',
  },
};

export const generalNameProperties = {
  required: 'Nome é obrigatório',
  ...minCharacters(),
  ...patternText,
};

export const generalPhoneProperties = {
  required: 'Celular é obrigatório',
  validate: (value) => phoneValidation(value) || 'Celular inválido',
  pattern: {
    value: /^\+?[0-9\s]{10,}$/,
    message: 'Celular inválido',
  },
};

export const generalCPFProperties = {
  required: 'CPF é obrigatório',
  pattern: {
    value: /^\d{3}\.\d{3}\.\d{3}-\d{2}$/,
    message: 'CPF inválido',
  },
  validate: (value) => isCPF(value) || 'CPF inválido',
};

export const cpfEmailValidator = async (value, email, setLoader) => {
  if (isCPF(value)) {
    setLoader(true);

    const client = await checkClient(value, email);

    setLoader(false);

    return client?.email && `CPF vinculado a ${client?.email}`;
  }

  return 'CPF inválido';
};

export const cardNameValidator = (value) =>
  (isValidNameOfCard(value) && hasInitialSpace(value)) ||
  'Nome completo é inválido';

export const generalCardNumberProperties = {
  required: 'Número do cartão de crédito é obrigatório',
  pattern: {
    value: /\d/,
    message: 'Número do cartão de crédito inválido',
  },
};

export const cardExpireValidator = (value) =>
  isValidExpire(value) || 'Validade expirada ou inválida';

export const generalCVVProperties = {
  required: 'CVV é obrigatório',
  pattern: {
    value: /\d/,
    message: 'Mínimo de 3 caracteres',
  },
};

export const generalCEPValidation = (value) => isCEP(value) || 'CEP inválido';

export const unRegisterPaymentForms = (isCreditCard, unRegisterFunction) => {
  if (isCreditCard) {
    const BankSlipProperties = [
      'cep',
      'address',
      'number',
      'city',
      'uf',
      'complement',
    ];

    loopHelper(BankSlipProperties, unRegisterFunction);
  } else {
    const cardProperties = [
      'cardName',
      'cardNumber',
      'expire',
      'cvv',
      'installments',
    ];

    loopHelper(cardProperties, unRegisterFunction);
  }
};

const loopHelper = (array, unRegisterFunction) => {
  let index = 0;

  for (index; index < array.length; index++) {
    unRegisterFunction(array[index]);
  }
};
